export default __webpack_public_path__ + "static/media/top2.aaa5fc97.png";